import { render, staticRenderFns } from "./MarketCategoryList.vue?vue&type=template&id=0ec69d76"
import script from "./MarketCategoryList.vue?vue&type=script&lang=js"
export * from "./MarketCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports